<ng-container *ngIf="activeUser$ | async as activeUser">
  <div class="officer-information-wrapper">
    <section
      class="information-container"
      *ngIf="officerInput && identificationTypes"
    >
      <div class="grid grid-cols-2 gap-2 text-sub">
        <div
          *ngIf="directorInput && directorInput.dateOfCessation"
          class="!mb-1 w-full flex flex-col"
        >
          <p class="block !mb-3">
            <span class="block mb-1 font-['OpenSans'] text-darkGray">Date of Cessation&colon;</span>
            <span
              class="block m-0 font-['OpenSans_Bold'] font-bold text-darkGray">{{ directorInput.dateOfCessation | date: "MMM dd, yyyy" }}</span>
          </p>
        </div>
      </div>

      <div class="grid grid-cols-2 gap-2 text-sub">
        <div
          *ngIf="directorInput && directorInput.dateOfAppointment"
          class="!mb-1 w-full flex flex-col"
        >
          <p class="block !mb-3">
            <span class="block mb-1 font-['OpenSans'] text-darkGray">Date of Appointment&colon;</span>
            <span
              class="block m-0 font-['OpenSans_Bold'] font-bold text-darkGray">{{ directorInput.dateOfAppointment | date: "MMM dd, yyyy" }}</span>
          </p>
        </div>
      </div>

      <!--      INDIVIDUAL INFORMATION-->
      <ng-container *ngIf="officerInputHelper.isIndividual(officerInput)">
        <div class="grid grid-cols-2 gap-2 text-sub">
          <div class="!mb-1 w-full flex flex-col">
            <p class="block !mb-3">
              <span class="block mb-1 font-['OpenSans'] text-darkGray">Position Held&colon;</span>
              <span
                class="block m-0 font-['OpenSans_Bold'] font-bold text-darkGray">{{ officerHelper.renderOfficerRole(officerType) }}</span>
            </p>
          </div>

          <div class="!mb-1 w-full flex flex-col">
            <p class="block !mb-3">
              <span class="block mb-1 font-['OpenSans'] text-darkGray">Name&colon;</span>
              <span class="block m-0 font-['OpenSans_Bold'] font-bold text-darkGray">{{
                  officerInputHelper.getOfficerName(
                    officerInput.officerPerson || officerInput.officerCompany
                  )
                }}</span>
            </p>
          </div>
          <ng-container *ngIf="!officerInputHelper.isNominee(officerInput)">
            <div class="!mb-1 w-full flex flex-col">
              <p class="block !mb-3">
                <span class="block mb-1 font-['OpenSans'] text-darkGray">Identification Document&colon;</span>
                <span class="block m-0 font-['OpenSans_Bold'] font-bold text-darkGray">{{
                    officerInputHelper.getIdentificationTypeName(
                      officerInput,
                      identificationTypes
                    )
                  }}</span>
              </p>
            </div>

            <div class="!mb-1 w-full flex flex-col">
              <p class="block !mb-3">
                <span class="block mb-1 font-['OpenSans'] text-darkGray">Identification No&colon;</span>
                <span
                  class="block m-0 font-['OpenSans_Bold'] font-bold text-darkGray">{{ officerInputHelper.getIdentificationNumber(officerInput) }}</span>
              </p>
            </div>

            <div class="!mb-1 w-full flex flex-col">
              <p class="block !mb-3">
                <span class="block mb-1 font-['OpenSans'] text-darkGray">Expiry Date&colon;</span>
                <span
                  class="block m-0 font-['OpenSans_Bold'] font-bold text-darkGray">{{
                    (officerInputHelper.getIdentificationExpiryDate(officerInput)
                      | date) || "-"
                  }}</span>
              </p>
            </div>

            <div class="!mb-1 w-full flex flex-col">
              <p class="block !mb-3">
                <span class="block mb-1 font-['OpenSans'] text-darkGray">Nationality&colon;</span>
                <span
                  class="block m-0 font-['OpenSans_Bold'] font-bold text-darkGray"> {{ officerInputHelper.getCountryName(officerInput, countries) }}</span>
              </p>
            </div>

            <div class="!mb-1 w-full flex flex-col">
              <p class="block !mb-3">
                <span class="block mb-1 font-['OpenSans'] text-darkGray">Email&colon;</span>
                <span
                  class="block m-0 font-['OpenSans_Bold'] font-bold text-darkGray"> {{
                    officerInputHelper.getOfficerEmail(
                      officerInput.officerCompany || officerInput.officerPerson
                    )
                  }}</span>
              </p>
            </div>

            <div class="!mb-1 w-full flex flex-col">
              <p class="block !mb-3">
                <span class="block mb-1 font-['OpenSans'] text-darkGray">Phone&colon;</span>
                <span
                  class="block m-0 font-['OpenSans_Bold'] font-bold text-darkGray">{{ officerInputHelper.getPhone(officerInput) }}</span>
              </p>
            </div>

            <div class="col-span-2 !mb-1 w-full flex flex-col">
              <p class="block !mb-3">
                <span class="block mb-1 font-['OpenSans'] text-darkGray">Address&colon;</span>
                <span
                  class="block m-0 font-['OpenSans_Bold'] font-bold text-darkGray">{{ officerInputHelper.getAddress(officerInput, countries) }}</span>
              </p>
            </div>
          </ng-container>
        </div>
      </ng-container>

      <!--      CORPORATE INFORMATION-->
      <ng-container *ngIf="officerInputHelper.isCorporate(officerInput)">
        <div class="grid grid-cols-2 gap-2 text-sub">
          <div class="!mb-1 w-full flex flex-col">
            <p class="block !mb-3">
              <span class="block mb-1 font-['OpenSans'] text-darkGray">Position Held&colon;</span>
              <span
                class="block m-0 font-['OpenSans_Bold'] font-bold text-darkGray"> {{ officerHelper.renderOfficerRole(officerType) }}</span>
            </p>
          </div>

          <div class="!mb-1 w-full flex flex-col">
            <p class="block !mb-3">
              <span class="block mb-1 font-['OpenSans'] text-darkGray">Corporate Name&colon;</span>
              <span
                class="block m-0 font-['OpenSans_Bold'] font-bold text-darkGray"> {{
                  officerInputHelper.getOfficerName(
                    officerInput.officerPerson || officerInput.officerCompany
                  )
                }}</span>
            </p>
          </div>

          <div class="!mb-1 w-full flex flex-col">
            <p class="block !mb-3">
              <span class="block mb-1 font-['OpenSans'] text-darkGray">Country of Incorporation&colon;</span>
              <span
                class="block m-0 font-['OpenSans_Bold'] font-bold text-darkGray"> {{ officerInputHelper.getCountryName(officerInput, countries) }}</span>
            </p>
          </div>

          <div class="!mb-1 w-full flex flex-col">
            <p class="block !mb-3">
              <span class="block mb-1 font-['OpenSans'] text-darkGray">Registration Number&colon;</span>
              <span
                class="block m-0 font-['OpenSans_Bold'] font-bold text-darkGray"> {{ officerInputHelper.getRegistrationNumber(officerInput) }}</span>
            </p>
          </div>

          <div class="!mb-1 w-full flex flex-col">
            <p class="block !mb-3">
              <span class="block mb-1 font-['OpenSans'] text-darkGray">Incorporation Date&colon;</span>
              <span
                class="block m-0 font-['OpenSans_Bold'] font-bold text-darkGray"> {{
                  (officerInputHelper.getRegistrationDate(officerInput) | date) ||
                  "-"
                }}</span>
            </p>
          </div>

          <div class="!mb-1 w-full flex flex-col">
            <p class="block !mb-3">
              <span class="block mb-1 font-['OpenSans'] text-darkGray">Email&colon;</span>
              <span
                class="block m-0 font-['OpenSans_Bold'] font-bold text-darkGray"> {{ officerInputHelper.getEmail(officerInput) }}</span>
            </p>
          </div>

          <div class="!mb-1 w-full flex flex-col">
            <p class="block !mb-3">
              <span class="block mb-1 font-['OpenSans'] text-darkGray">Phone&colon;</span>
              <span
                class="block m-0 font-['OpenSans_Bold'] font-bold text-darkGray">  {{ officerInputHelper.getPhone(officerInput) }}</span>
            </p>
          </div>

          <div class="col-span-2 !mb-1 w-full flex flex-col">
            <p class="block !mb-3">
              <span class="block mb-1 font-['OpenSans'] text-darkGray">Address&colon;</span>
              <span
                class="block m-0 font-['OpenSans_Bold'] font-bold text-darkGray">{{ officerInputHelper.getAddress(officerInput, countries) }}</span>
            </p>
          </div>
        </div>
      </ng-container>
    </section>
  </div>
</ng-container>
